import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../../services/filtering/filter-form-render-service/option-form-types';
import { DestinationComponent } from './component';
import { Destination as OrdersDestinationActionableFilterPill } from '../../../../../components/actionable-filter-pill/connected/orders/destination';
import { isOperator, isNotOperator } from '../../../../../filters/operators/collection';
import { messages } from '../messages';

export const Destination = {
  id: 'destination',
  displayName: <FormattedMessage {...messages.destination} />,
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER,
  filterValue: 'ShipToCountryCode',
  render: (criteriaInformations) => <DestinationComponent criteriaInformations={criteriaInformations} />,
  actionableFilterPill: OrdersDestinationActionableFilterPill,
  expectsArgumentAsArray: true,

  mapV2SavedFilterToV3Applied: (filter, metadata) => {
    const operator = filter.value ? isNotOperator.name : isOperator.name;
    return {
      criterionOperatorValue: operator,
      criterionArgumentValue: metadata.sellerHomeCountry,
    };
  },
};
